import React from 'react'
import { withI18nContext } from '@mc/i18n'
import { BannerOfferSloganBlue, UrgencyTextGreen } from '../../featureVariables'
import { i18nInstance } from '../../i18n'
import classes from './StickyFooterContent.module.scss'

const StickyFooterContentComp = ({
  SignUpCta,
  PricingText,
}: {
  SignUpCta: React.ComponentType
  PricingText: React.ComponentType<{ translationKey: 'short' }>
}) => (
  <div className='container mc-p-4'>
    {/* Desktop view */}
    <div className='d-none d-sm-flex align-items-center justify-content-between'>
      <div className='d-flex flex-wrap align-items-center'>
        <StickyFooterContentTitle />
        <p className='mc-text-small'>
          <UrgencyTextGreen />
        </p>
      </div>
      <div className='d-flex align-items-center mc-ml-2'>
        <p className='mc-text-h7 mc-mr-2 mc-mr-md-4'>
          <PricingText translationKey='short' />
        </p>
        <SignUpCta />
      </div>
    </div>
    {/* Mobile view */}
    <div className='d-flex d-sm-none flex-column mc-gap-3'>
      <div className='d-flex align-items-center justify-content-between mc-gap-4'>
        <StickyFooterContentTitle />
        <SignUpCta />
      </div>
      <div
        className={`d-flex justify-content-between mc-gap-4 ${classes.bottomContainer}`}
      >
        <p
          className='mc-font-caption align-self-end'
          style={{ minWidth: '33%' }}
        >
          <UrgencyTextGreen />
        </p>
        <p className='mc-font-caption mc-text--right'>
          <PricingText translationKey='short' />
        </p>
      </div>
    </div>
  </div>
)

const StickyFooterContentTitle = () => (
  <p
    className='mc-text--brand mc-text--uppercase mc-mr-6'
    style={{ fontSize: '28px' }}
  >
    <BannerOfferSloganBlue ignoreStyle={true} />
  </p>
)

export const StickyFooterContent = withI18nContext(i18nInstance)(
  StickyFooterContentComp,
)
